import { useCallback } from 'react';
import { prop } from 'ramda';
import { useGetURLTemplate } from 'server';
import { useAppSelector } from 'js/store/hooks';

import * as Types from '../types';

export const useGetTemplateUrl = () => {
    const getURLTemplate = useGetURLTemplate();
    const rootPage = useAppSelector(prop('rootPage'));

    return useCallback(({
        priority, templateType, setTemplateUrl
    }: Types.IGetTemplateUrlParams): void => {

        (async () => {
            try {
                const templateUrl = await getURLTemplate({ urlTypeList: [templateType], priority: Number(priority) });

                setTemplateUrl(templateUrl || rootPage);
            } catch {
                setTemplateUrl(rootPage);
            }
        })();
    }, [getURLTemplate, rootPage]);
};
